import { useParams } from 'react-router-dom';

import Form from '@gef-ui/form-material/Form';

import formDescriptorFn, { CAMPAIGN_MANAGEMENT_FORM_NAME } from 'features/views/campaignManagement/campaignDetail/form';
import CampaignManagement, { Sidebar } from 'pages/CampaignManagement';

import PageLayout from '../components/PageLayout';

const CampaignManagementPage = () => {
	const { campaignId } = useParams();

	return (
		<PageLayout aside={<Sidebar campaignId={campaignId} />}>
			<div className="Page-main">
				<Form name={CAMPAIGN_MANAGEMENT_FORM_NAME} formDescriptorFn={formDescriptorFn}>
					<CampaignManagement campaignId={campaignId} />
				</Form>
			</div>
		</PageLayout>
	);
};

export default CampaignManagementPage;
